'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PasswordInput = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(PasswordInput, _Component);

  function PasswordInput() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PasswordInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PasswordInput.__proto__ || (0, _getPrototypeOf2.default)(PasswordInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      passwordFiledType: 'password'
    }, _this.value = '', _this.handleClickShowHide = function () {
      var passwordFiledType = _this.state.passwordFiledType;

      if (passwordFiledType === 'password') {
        _this.setState({ passwordFiledType: 'text' });
      } else {
        _this.setState({ passwordFiledType: 'password' });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PasswordInput, [{
    key: 'handleChangePassword',
    value: function handleChangePassword(event) {
      var onChange = this.props.onChange;

      this.value = event.target.value.trim();

      if (onChange) {
        onChange(event);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var passwordFiledType = this.state.passwordFiledType;
      var _props = this.props,
          className = _props.className,
          defaultValue = _props.defaultValue,
          id = _props.id,
          placeholder = _props.placeholder,
          polyglot = _props.polyglot;


      return _react2.default.createElement(
        'div',
        { className: 'hideShowPassword' },
        _react2.default.createElement('input', {
          ref: 'password',
          id: id,
          type: passwordFiledType,
          className: className,
          defaultValue: defaultValue,
          onChange: this.handleChangePassword.bind(this),
          placeholder: placeholder
        }),
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-link unmask',
            title: 'Mask/Unmask password to check content',
            onClick: this.handleClickShowHide.bind(this)
          },
          passwordFiledType === 'password' ? polyglot.t('button.show') : polyglot.t('button.hide')
        )
      );
    }
  }]);
  return PasswordInput;
}(_react.Component), _class.propTypes = {
  className: _propTypes2.default.string,
  defaultValue: _propTypes2.default.string,
  id: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  polyglot: _propTypes2.default.object.isRequired
}, _class.defaultProps = {
  isActive: false
}, _temp2);
exports.default = PasswordInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/PasswordInput.js
// module id = 2219
// module chunks = 0